// Modules
import React, { createContext } from "react"; // eslint-disable-line

const ApiContext = createContext({
    isMobile: false,
    isTablet: false,
});

export default ApiContext;
